var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature2Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79199 1.66406C12.6682 1.66424 14.9998 3.99585 15 6.87207V8.95605C16.1506 8.95605 17.083 9.88847 17.083 11.0391V16.2471C17.083 17.3977 16.1506 18.3311 15 18.3311H4.58301C3.43256 18.3309 2.5 17.3976 2.5 16.2471V11.0391C2.5 9.88858 3.43256 8.95623 4.58301 8.95605V6.87207C4.58318 3.99574 6.91562 1.66406 9.79199 1.66406ZM9.79199 3.74707C8.06621 3.74707 6.66717 5.14633 6.66699 6.87207V8.95605H12.917V6.87207C12.9168 5.14644 11.5176 3.74725 9.79199 3.74707Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79199 1.66406C12.6682 1.66424 14.9998 3.99585 15 6.87207V8.95605C16.1506 8.95605 17.083 9.88847 17.083 11.0391V16.2471C17.083 17.3977 16.1506 18.3311 15 18.3311H4.58301C3.43256 18.3309 2.5 17.3976 2.5 16.2471V11.0391C2.5 9.88858 3.43256 8.95623 4.58301 8.95605V6.87207C4.58318 3.99574 6.91562 1.66406 9.79199 1.66406ZM9.79199 3.74707C8.06621 3.74707 6.66717 5.14633 6.66699 6.87207V8.95605H12.917V6.87207C12.9168 5.14644 11.5176 3.74725 9.79199 3.74707Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2Icon);
export default __webpack_public_path__ + "static/media/feature-2-icon.3873476d8fc153410887bb119646955f.svg";
export { ForwardRef as ReactComponent };